import { AssignedWireType } from '@/types/wireTypes';
import { authApiService } from '../../authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const getExecutorWireApi = (wireId: string): Promise<ApiResponseType<AssignedWireType>> => {
  const uri = `/executor/wires/${wireId}/`;

  return authApiService.GET(uri);
};
